// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1CARN","row":"Node_row__3pTxN","label":"Node_label__3UvE_","footer":"Node_footer__30ZlW"};